import classes from './FormField.module.sass'
import { CategoryAttribute, ItemAttribute } from '../../../../types/interfaces'
import { FieldType } from '../../../../types/enums'
import { DynamicInput } from '../dynamicInput/DynamicInput'
import { DynamicSelect } from '../dynamicSelect/DynamicSelect'
import { DynamicToggle } from '../dynamicToggle/DynamicToggle'

type Props = {
  el: ItemAttribute
  onChange: (id: string, value: string | string[] | boolean) => void
}

export const FormField = ({ el, onChange,}: Props) => {
  switch (el.fieldType) {
    case FieldType.INPUT:
      return (
        <div>
          <DynamicInput
            el={el}
            onChange={onChange}
   
          />
        </div>
      )
    case FieldType.SELECT:
    case FieldType.MULTISELECT:
      return (
        <div>
          <DynamicSelect
            el={el}
            onChange={onChange}
          
          />
        </div>
      )

    case FieldType.CHECKBOX:
      return (
        <div>
          <DynamicToggle el={el} onChange={onChange} />
        </div>
      )

    default:
      return <></>
  }
}
